import supercluster from "points-cluster";
import { push } from "redux-little-router";
import { onSetResults } from "./content";
import { onShowGlobalAlert } from "./ui";

export const changeMap = (mapOptions) => {
  // alert(mapOptions.center.lng);
  return {
    type: "CHANGE_MAP",
    mapOptions: mapOptions
  };
};
export function onChangeMap(mapOptions) {
  return (dispatch, getState) => {
    const { router } = getState();
    const { resultsShown } = getState().brc;
    var url = window.location.href;
    var setUrl = false;
    // var path = router.pathname.split('/');
    if (url.indexOf("utm") === -1) {
      setUrl = true;
    } else if (!!resultsShown) {
      setUrl = true;
    }
    // console.log(setUrl);
    if (!!setUrl) {
      var newUrl =
        "/" +
        mapOptions.center.lat +
        "/" +
        mapOptions.center.lng +
        "/" +
        mapOptions.zoom;
      dispatch(push(newUrl));
    }
    // console.log(mapOptions);
    dispatch(changeMap(mapOptions));
  };
}

export const saveClusters = (clusters) => {
  return {
    type: "SAVE_CLUSTERS",
    clusters: clusters
  };
};
export function onSaveClusters() {
  return (dispatch, getState) => {
    const { locations, mapOptions } = getState().brc;
    const sc = supercluster(locations, {
      minZoom: 0,
      maxZoom: 16,
      radius: 60
    });
    const clusters = sc(mapOptions).map(({ wx, wy, numPoints, points }) => ({
      lat: wy,
      lng: wx,
      numPoints,
      id: `${numPoints}_${points[0].id}`,
      points,
      ids: `${points.map((point) => point.id)}`
    }));
    dispatch(saveClusters(clusters));
    dispatch(onSetResults());
    dispatch(onShowGlobalAlert());
  };
}

export const setHover = (id) => {
  return {
    type: "SET_HOVER",
    id: id
  };
};
export function onSetHover(id) {
  return (dispatch, getState) => {
    dispatch(setHover(id));
  };
}

export const saveMap = (map) => {
  return {
    type: "SAVE_MAP",
    map: map
  };
};
export function onSaveMap(map) {
  return (dispatch, getState) => {
    dispatch(saveMap(map));
  };
}

export const saveMaps = (maps) => {
  return {
    type: "SAVE_MAPS",
    maps: maps
  };
};
export function onSaveMaps(maps) {
  return (dispatch, getState) => {
    dispatch(saveMaps(maps));
  };
}

export const reCenterMap = (options) => {
  return {
    type: "RECENTER_MAP",
    options: options
  };
};
export function onReCenterMap(lat, lng, zoom) {
  return (dispatch, getState) => {
    const { mapOptions, map, maps } = getState().brc;

    if (zoom) z = zoom;
    else z = mapOptions.zoom;

    var offsety = 180,
      z;
    var scale = Math.pow(2, z);
    var latlng = new maps.LatLng(lat, lng);
    var worldCoordinateCenter = map.getProjection().fromLatLngToPoint(latlng);
    var pixelOffset = new maps.Point(0, offsety / scale || 0);
    var worldCoordinateNewCenter = new maps.Point(
      worldCoordinateCenter.x - pixelOffset.x,
      worldCoordinateCenter.y + pixelOffset.y
    );
    var newCenter = map
      .getProjection()
      .fromPointToLatLng(worldCoordinateNewCenter);

    //Bounds
    var SW = new maps.LatLng(
      mapOptions.bounds.sw.lat,
      mapOptions.bounds.sw.lng
    );
    var NE = new maps.LatLng(
      mapOptions.bounds.ne.lat,
      mapOptions.bounds.ne.lng
    );
    var topRight = map.getProjection().fromLatLngToPoint(NE);
    var bottomLeft = map.getProjection().fromLatLngToPoint(SW);

    var SWpoint = new maps.Point(
      (bottomLeft.x - bottomLeft.x) * scale,
      (bottomLeft.y - topRight.y) * scale - 420
    );
    var SWworld = new maps.Point(
      SWpoint.x / scale + bottomLeft.x,
      SWpoint.y / scale + topRight.y
    );
    var newSW = map.getProjection().fromPointToLatLng(SWworld);

    var newBounds = {
      ne: mapOptions.bounds.ne,
      nw: mapOptions.bounds.nw,
      se: {
        lat: newSW.lat(),
        lng: mapOptions.bounds.ne.lng
      },
      sw: {
        lat: newSW.lat(),
        lng: mapOptions.bounds.nw.lng
      }
    };
    var options = {
      center: {
        lat: newCenter.lat(),
        lng: newCenter.lng()
      },
      zoom: z,
      bounds: newBounds
    };

    dispatch(reCenterMap(options));
  };
}



// WEBPACK FOOTER //
// ./src/store/actions/map.js